import { ChevronRight, ExpandMoreOutlined } from '@mui/icons-material'
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Input,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'
import {
  CalendarIcon,
  FilterIcon,
  ResetIcon,
  SearchIcon,
} from '../../assets/icons/icons'
import {
  useDeleteEmployeeAttendance,
  useGetEmployeeAttendance,
  useUpdateEmployeeAttendance,
} from './hooks'
import { useGetProjectsAll } from '../projects/hooks'
import Project from '../../types/Project'
import {
  dateDiffInHours,
  dateDiffInMinuteWithHours,
  dateDiffInMinutes,
  formatDate,
  formatDateMMDDYYYY,
  formatTime,
  guessUserTZ,
  toHourTimeAlt,
} from '../../lib/time'
import EditTimesheetModel from './EditTimesheetModel'
import moment from 'moment-timezone'

import Api from '../../lib/api'
import { useAuth0 } from '@auth0/auth0-react'
import { SnackbarComponent } from '../../components/Snackbar'
import { v4 as uuidv4 } from 'uuid'
import amazonService from '../../lib/aws'
import * as Sentry from '@sentry/react'

// @ts-ignore
import Excel from 'exceljs'
import ViewWorkerModel from './ViewWorkerModel'
import { GridRowId } from '@mui/x-data-grid'
import DeleteModal from '../../components/DeleteModal'
import { useParams } from 'react-router-dom'
import SnackBarContext from '../../context/SnackBarContext'
import { useGetQuestions } from '../Adminquestion/HrQuestionhook'

interface FormData {
  project?: any
  employeeName?: any
  startWorkingHour?: any
  endWorkingHour?: any
  archived?: any
  checkedin?: any
  date?: any
  exportType?: any
  endTimeStamp?: any
}

const emptyMutation = () => ({
  mutate: null,
  isLoading: null,
})

function EmployeesAttendanceReport(props: any) {
  const { useDeleteEmployeeAttendance = emptyMutation, queryKey } = props
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openLimit, setOpenLimit] = useState<null | HTMLElement>(null)
  const [openExportType, setOpenExportType] = useState<null | HTMLElement>(null)
  const { mutate: deleteMutate } = useDeleteEmployeeAttendance(queryKey)
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [exportType, setExportType] = useState('gusto')
  const open = Boolean(anchorEl)
  const [formData, setFormData] = useState<FormData>({
    date: null,
    employeeName: '',
    project: 0,
    archived: 0,
    checkedin: 0,
    startWorkingHour: 0,
    endWorkingHour: 0,
    endTimeStamp: null,
    exportType: 'gusto',
  })
  const { getAccessTokenSilently } = useAuth0()
  const [loading, setLoading] = useState(false)
  const [snakbarOptions, setSnakbarOptions] = useState({
    open: false,
    type: '',
    message: '',
  })
  const { data: projects, isFetching: isFetchingProjects } =
    useGetProjectsAll('projects')
  let { date, endTimeStamp } = useParams()
  let [filterParam, setFilterParam] = useState('')
  let [selectedTimesheets, setSelectedTimesheets] = useState({})
  const { data: hrQuestions, refetch, isLoading } = useGetQuestions('questions')

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onChangeFormData = (event: any) => {
    setFormData({
      ...formData,
      startWorkingHour:
        event.target.name === 'startWorkingHour'
          ? event.target.value
          : formData.startWorkingHour,
      endWorkingHour:
        event.target.name === 'endWorkingHour'
          ? event.target.value
          : formData.endWorkingHour,
      [event.target.name]: event.target.value as string,
    })
  }

  const getParam = () => {
    var param = ''
    if (formData.archived != null && formData.archived !== 0) {
      param += `isArchived=${formData.archived}&`
    }
    if (formData.checkedin != null && formData.checkedin != 0) {
      param += `isCheckedIn=${formData.checkedin}&`
    }
    if (formData.employeeName) {
      param += `employeeName=${formData.employeeName}&`
    }
    if (formData.project) {
      param += `project=${formData.project}&`
    }
    if (
      formData.date != null &&
      formData.date != undefined &&
      formData.date != ''
    ) {
      const year = formData.date.$y
      const month = formData.date.$M + 1
      const day = formData.date.$D
      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${
        day < 10 ? '0' : ''
      }${day}`
      param += `date=${formattedDate}&`
    }

    if (formData.startWorkingHour != null && formData.startWorkingHour != 0) {
      param += `startWorkingHour=${formData.startWorkingHour}&`
    }
    if (formData.endWorkingHour != null && formData.endWorkingHour != 0) {
      param += `endWorkingHour=${formData.endWorkingHour}&`
    }

    if (param.toString().length > 0) {
      param += `timezone=${guessUserTZ()}&`
    }

    // Get open timecards
    if (formData.endTimeStamp === null) {
      param += `endTimeStamp=null&`
    }

    return param
  }

  const handleFilter = () => {
    const param = getParam()
    setFilterParam(param)
  }

  const resetFilters = () => {
    setFilterParam('')
    setFormData({
      date: null,
      employeeName: '',
      project: 0,
      archived: 0,
      checkedin: 0,
      startWorkingHour: 0,
      endWorkingHour: 0,
    })
  }

  const handleUploadClick = async (exportType: string) => {
    setLoading(true)
    try {
      var employees = {
        data: [],
      }
      if (exportType !== 'Selected Timecards') {
        var projectsSTR = projects
          .map((item: any) => item.id.toString())
          .join(',')
          .toString()
        var paramStr = ''
        paramStr += 'project=' + projectsSTR + '&'
        paramStr += `timezone=${moment.tz.guess()}&limit=9999999&`
        var { startTime, endTime } = getTimeRange(exportType)
        paramStr += `startTimeStamp=${startTime}&endTimeStamp=${endTime}&`
        try {
          var token = await getAccessTokenSilently()
          employees = await Api.get(`v1/timecards?${paramStr}`, token)
        } catch (err) {}
      } else {
        // @ts-ignore
        employees['data'] = (Object.values(selectedTimesheets) ?? [])?.filter(
          (item: any) => item != null
        )
      }
      if (formData?.exportType !== '') {
        try {
          if ((employees?.data?.length ?? 0) > 0) {
            const excelBlob = await generateExcelFile(employees?.data)
            const fileName = `${
              formData?.exportType
                ? formData?.exportType
                : 'Employee Attendance'
            } Report ${moment().format('DD.MM.YY')}`
            const file = new File([excelBlob], fileName, {
              type:
                formData?.exportType === 'gusto'
                  ? 'text/csv'
                  : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            // Create a URL for the file
            const fileURL = URL.createObjectURL(file)
            const downloadLink = document.createElement('a')
            downloadLink.href = fileURL
            downloadLink.download = `${fileName}.${
              formData?.exportType === 'gusto' ? 'csv' : 'xlsx'
            }` // The name of the downloaded file
            document.body.appendChild(downloadLink) // Append the link to the document
            downloadLink.click() // Programmatically click the link to trigger the download
            setSnakbarOptions({
              open: true,
              message: 'File has been downloaded successfully!',
              type: 'success',
            })
            URL.revokeObjectURL(downloadLink.href)
            document.body.removeChild(downloadLink)
            setTimeout(() => {
              setSnakbarOptions({ ...snakbarOptions, open: false })
            }, 3000)
          } else {
            setSnakbarOptions({
              open: true,
              message: 'There are no timecards to export!',
              type: 'error',
            })
            setTimeout(() => {
              setSnakbarOptions({ ...snakbarOptions, open: false })
            }, 3000)
          }
        } catch (error) {
          console.error('Error generating or uploading the file:', error)
          Sentry.captureException(error)
        }
      } else {
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }

  const getTimeRange = (selectedType: string) => {
    let startTime, endTime

    endTime = moment().endOf('day').unix()

    switch (selectedType) {
      case "Last Week's Projects":
        startTime = moment().startOf('week').subtract(1, 'weeks').unix()
        endTime = moment().startOf('week').subtract(1, 'seconds').unix()
        break
      case "Last Month's Projects":
        startTime = moment().subtract(1, 'months').startOf('month').unix()
        endTime = moment().subtract(1, 'months').endOf('month').unix()
        break
      case "Last Year's Projects":
        startTime = moment().subtract(1, 'years').startOf('year').unix()
        endTime = moment().subtract(1, 'years').endOf('year').unix()
        break
      case 'This Year':
        startTime = moment().startOf('year').unix()
        break
      case 'All Time':
        startTime = moment(0).unix()
        break
      default:
        startTime = moment().unix()
    }

    return { startTime, endTime }
  }

  async function generateExcelFile(employees: any) {
    let workbook = new Excel.Workbook()
    if (formData.exportType !== 'gusto') {
      let worksheet1 = workbook.addWorksheet('General')
      worksheet1.columns = [
        { header: 'Worker Name', key: 'employee', width: 20 },
        { header: 'Project', key: 'Project', width: 15 },
        { header: 'Date', key: 'Date', width: 15 },
        { header: 'Check IN', key: 'Checkin', width: 15 },
        { header: 'Check Out', key: 'Checkout', width: 15 },
        { header: 'total', key: 'total', width: 10 },
        { header: 'Regular', key: 'Regular', width: 10 },
        { header: 'Overtime', key: 'Overtime', width: 10 },
        { header: 'Doubletime', key: 'Doubletime', width: 10 },
      ]
      const data = employees
      const uniqueUsersWithCompany = data.reduce(
        (acc: any, currentItem: any) => {
          // Check if the user is already included in the accumulator based on user _id
          const userExists = acc.find(
            (user: any) => user.user_id === currentItem.user._id
          )

          // If the user doesn't exist, add them to the accumulator with the company name and user.IdNumber
          if (!userExists) {
            acc.push({
              fullName: currentItem?.user?.fullName,
              company: currentItem?.project?.projectName, // Extracting company from project.clientName
              endDate: currentItem?.endTimeStamp
                ? currentItem?.endTimeStamp
                : currentItem?.startTimeStamp,
              checkIn: currentItem?.formattedTimeDurations?.startTime
                ? currentItem?.formattedTimeDurations?.startTime
                : null, // Include the user's _id for reference
              checkout: currentItem?.formattedTimeDurations?.endTime
                ? currentItem?.formattedTimeDurations?.endTime
                : null,
              total: currentItem?.totalTimeWorkedInMinutes,
              Regular: currentItem?.formattedTimeDurations.regularTimeWorked,
              Overtime: currentItem?.formattedTimeDurations.overTimeWorked,
              Doubletime:
                currentItem?.formattedTimeDurations.doubleOverTimeWorked,
            })
          }

          return acc
        },
        []
      )

      uniqueUsersWithCompany?.forEach((item: any) => {
        worksheet1.addRow({
          employee: item?.fullName,
          Project: item?.company,
          Date: item?.endDate ? formatDate(item?.endDate) : '--',
          Checkin: formatTime(item?.checkIn),
          Checkout: item?.checkout ? formatTime(item?.checkout) : 'open',
          total:
            item?.checkout == null
              ? ''
              : dateDiffInMinuteWithHours(item?.checkIn, item?.checkout),
          Regular: item?.Regular,
          Overtime: item?.Overtime,
          Doubletime: item?.Doubletime,
        })
      })
    }
    let worksheet = workbook.addWorksheet(
      formData.exportType === 'gusto' ? 'My Sheet' : 'Distribution'
    )

    if (formData.exportType === 'gusto') {
      worksheet.columns = [
        { header: 'First Name', key: 'firstName', width: 20 },
        { header: 'Last Name', key: 'lastName', width: 20 },
        { header: 'Gusto Employee ID', key: 'gustoEmployeeID', width: 20 },
        { header: 'Check In', key: 'checkIn', width: 20 },
        { header: 'Check Out', key: 'checkOut', width: 20 },
        { header: 'Total Time', key: 'totalTime', width: 20 },
        { header: 'Regular Hours', key: 'regularHours', width: 10 },
        { header: 'Overtime Hours', key: 'overtimeHours', width: 15 },
      ]
      employees?.forEach((item: any) => {
        worksheet.addRow({
          firstName: item?.user?.firstName,
          lastName: item?.user?.lastName,
          gustoEmployeeID: item?.user?.idNumber,
          checkIn: formatTime(item?.startTimeStamp),
          checkOut: formatTime(item?.endTimeStamp),
          totalTime: item?.totalTimeWorkedInMinutes,
          regularHours: item?.formattedTimeDurations?.regularTimeWorked,
          overtimeHours: item?.formattedTimeDurations?.overTimeWorked,
        })
      })
    } else {
      worksheet.columns = [
        { header: 'Company', key: 'Company', width: 20 },
        { header: 'Employee', key: 'Employee', width: 20 },
        { header: 'Line Number', key: 'LineNumber', width: 15 },
        { header: 'Overwrite Line', key: 'OverwriteLine', width: 20 },
        { header: 'Date Worked', key: 'DateWorked', width: 20 },
        { header: 'Transaction Type', key: 'TransactionType', width: 20 },
        {
          header: 'Distribution Company',
          key: 'DistributionCompany',
          width: 25,
        },
        { header: 'Profit Center', key: 'ProfitCenter', width: 20 },
        {
          header: 'Allow Posting to Closed Profit Center',
          key: 'AllowPostingToClosedProfitCenter',
          width: 35,
        },
        { header: 'Cost Code', key: 'CostCode', width: 15 },
        { header: 'CMR', key: 'CMR', width: 10 },
        { header: 'Division', key: 'Division', width: 20 },
        { header: 'Work Location', key: 'WorkLocation', width: 20 },
        { header: 'Trade Union', key: 'TradeUnion', width: 20 },
        { header: 'Pay Class', key: 'PayClass', width: 15 },
        { header: 'Cost Type', key: 'CostType', width: 15 },
        { header: 'Paid Time Off', key: 'PaidTimeOff', width: 15 },
        {
          header: 'Allow PTO Before Available for Use Date',
          key: 'AllowPTOBeforeAvailableForUseDate',
          width: 40,
        },
        {
          header: 'Allow PTO over Balance',
          key: 'AllowPTOOverBalance',
          width: 25,
        },
        {
          header: 'Payroll Cost Account',
          key: 'PayrollCostAccount',
          width: 25,
        },
        {
          header: 'Insurance Classification',
          key: 'InsuranceClassification',
          width: 25,
        },
        { header: 'Start Time', key: 'StartTime', width: 15 },
        { header: 'End Time', key: 'EndTime', width: 15 },
        { header: 'Regular Hours', key: 'RegularHours', width: 15 },
        { header: 'Regular Rate', key: 'RegularRate', width: 15 },
        { header: 'Overtime Hours', key: 'OvertimeHours', width: 15 },
        { header: 'Overtime Rate', key: 'OvertimeRate', width: 15 },
        { header: 'Doubletime Hours', key: 'DoubletimeHours', width: 20 },
        { header: 'Doubletime Rate', key: 'DoubletimeRate', width: 20 },
        { header: 'Number Of Pieces', key: 'NumberOfPieces', width: 20 },
        { header: 'Amount', key: 'Amount', width: 15 },
        { header: 'Overtime Exempt', key: 'OvertimeExempt', width: 20 },
        { header: 'Description', key: 'Description', width: 25 },
        { header: 'Meter Reading', key: 'MeterReading', width: 20 },
        ...hrQuestions?.map((item: any) => {
          return {
            header: item?.questions[0]?.questionText,
            key: item?.questions[0]?.questionText,
            width: item?.questions[0]?.questionText?.length * 1.5,
          }
        }),
        // { header: 'Injured', key: 'Injured', width: 15 },
        // { header: 'Water', key: 'Water', width: 15 },
        // { header: 'Break', key: 'Break', width: 15 },
        // { header: 'Issue', key: 'Issue', width: 15 },
        // { header: 'Lunch Break', key: 'LunchBreak', width: 20 },
      ]

      try {
        employees?.forEach((data: any) => {
          let currentCostCodeIndex = 0
          // Add worksheet row
          addWorksheetRow(worksheet, data, currentCostCodeIndex)
          currentCostCodeIndex = 1
          while (data.costCodes.length > currentCostCodeIndex) {
            addWorksheetRow(worksheet, data, currentCostCodeIndex)
            currentCostCodeIndex++
          }
        })
      } catch (err) {
        console.log('err:', err)
        Sentry.captureException(err)
      }
    }

    // Convert workbook to a Blob
    const buffer = await (formData.exportType === 'gusto'
      ? workbook.csv.writeBuffer()
      : workbook.xlsx.writeBuffer())
    const blob = new Blob([buffer], {
      type:
        formData.exportType === 'gusto'
          ? 'text/csv'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    return blob
  }

  const addWorksheetRow = (
    worksheet: any,
    data: any,
    currentCostCodeIndex: number
  ) => {
    const costCodePercentageWorked =
      data.costCodes[currentCostCodeIndex]?.percentage || 0
    const adjustedRegularHours = (
      ((data?.regularTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)
    const adjustedOvertimeHours = (
      ((data?.overTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)
    const adjustedDoubletimeHours = (
      ((data?.doubleOverTimeWorkedInMinutes ?? 0) *
        (costCodePercentageWorked / 100)) /
      60
    ).toFixed(2)

    const RegularHours = data?.regularTimeWorkedInMinutes
      ? adjustedRegularHours
      : data.formattedTimeDurations.endTime
      ? '0'
      : '0'
    const OvertimeHours = data?.overTimeWorkedInMinutes
      ? adjustedOvertimeHours
      : '0'
    const DoubletimeHours = data?.doubleOverTimeWorkedInMinutes
      ? adjustedDoubletimeHours
      : '0'

    worksheet.addRow({
      Company: data?.project?.clientName,
      Employee: data?.user.idNumber,
      LineNumber: '',
      OverwriteLine: '',
      DateWorked: formatDateMMDDYYYY(data.formattedTimeDurations.startTime),
      TransactionType: 'Project Cost',
      DistributionCompany: '',
      ProfitCenter: data.project.projectNumber,
      AllowPostingToClosedProfitCenter: '',
      CostCode:
        data.costCodes.length === 0
          ? ''
          : data.costCodes![
              currentCostCodeIndex
            ]?.costCodeDetail![0]?.label.split('-')[0],
      CMR: '',
      Division: data.project.division,
      WorkLocation: '',
      TradeUnion: '',
      PayClass: '',
      CostType: 'Labor',
      PaidTimeOff: '',
      AllowPTOBeforeAvailableForUseDate: '',
      AllowPTOOverBalance: '',
      PayrollCostAccount: '',
      InsuranceClassification: '',
      StartTime: toHourTimeAlt(data.formattedTimeDurations.startTime),
      EndTime: data.formattedTimeDurations.endTime
        ? toHourTimeAlt(data.formattedTimeDurations.endTime)
        : 'Open',
      RegularHours,
      RegularRate: '',
      OvertimeHours,
      OvertimeRate: '',
      DoubletimeHours,
      DoubletimeRate: '',
      NumberOfPieces: '',
      Amount: '',
      OvertimeExempt: '',
      Description:
        data.costCodes.length === 0
          ? ''
          : data.costCodes![currentCostCodeIndex]?.description ?? '',
      MeterReading: '',
      ...data?.clockOutAnswers?.reduce((acc: any, b: any) => {
        acc[b?.question] = b?.answerText
        return acc
      }, {}),
      // Injured:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[0]
      //     ? data.clockOutAnswers[0].answer
      //     : '',
      // Water:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[1]
      //     ? data.clockOutAnswers[1].answer
      //     : '',
      // Break:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[2]
      //     ? data.clockOutAnswers[2].answer
      //     : '',
      // Issue:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[4]
      //     ? data.clockOutAnswers[4].answer
      //     : '',
      // LunchBreak:
      //   data.clockOutAnswers.length > 0 && data.clockOutAnswers[3]
      //     ? data.clockOutAnswers[3].answer
      //     : '',
    })
  }

  useEffect(() => {
    setFormData(prevFormData => ({
      ...prevFormData,
      date: date ? new Date(date) : null,
      endTimeStamp: endTimeStamp === 'null' ? null : endTimeStamp, // Add this line
    }))
  }, [date, endTimeStamp])

  return (
    <>
      <Box sx={{ marginLeft: 2, marginRight: 2, marginBottom: 0 }}>
        <Box
          alignItems={'center'}
          justifyContent={'space-between'}
          display={'flex'}>
          <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
            Employees Attendance Report
          </Typography>
          <div>
            <Button
              aria-controls='customized-menu'
              aria-haspopup='true'
              variant='contained'
              onClick={handleClick}
              sx={{
                backgroundColor: '#24212C',
                color: theme.palette.common.white,
                '&:hover': {
                  backgroundColor: '#24212C',
                },
                boxShadow: theme.shadows[1],
                borderRadius: '8px',
                fontSize: '14px',
                textTransform: 'capitalize',
                padding: '10px 16px',
              }}
              endIcon={<ChevronRight sx={{ transform: 'rotate(90deg)' }} />}>
              {formData?.exportType === 'pro-contractor'
                ? 'Pro Contractor'
                : formData.exportType === 'gusto'
                ? 'Gusto'
                : 'Gusto'}
            </Button>
            <Menu
              id='simple-menu'
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              style={{ width: '333px' }}>
              <MenuItem
                onClick={() => {
                  handleClose()
                  setFormData({ ...formData, exportType: 'gusto' })
                }}>
                Gusto
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose()
                  setFormData({ ...formData, exportType: 'pro-contractor' })
                }}>
                Pro Contractor
              </MenuItem>
              {/* Add more MenuItem components as needed */}
            </Menu>
          </div>
        </Box>

        <Box sx={{ marginTop: 2 }}>
          <Grid container spacing={2} alignItems='start' sx={{ mb: 2 }}>
            <Grid item sm={3}>
              <Box
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: theme.spacing(1.2, 1.6, 1.2, 1.6),
                }}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}>
                <Input
                  disableUnderline
                  value={formData.employeeName}
                  name='employeeName'
                  sx={{
                    width: '100%',
                    fontSize: '13px',
                    '& input::placeholder': {
                      fontWeight: 'bold',
                    },
                  }}
                  onChange={onChangeFormData}
                  placeholder='Search by Employee Name'
                  inputProps={{ 'aria-label': 'search' }}
                />
                <div>
                  <SearchIcon />
                </div>
              </Box>
            </Grid>
            <Grid item sm={3}>
              <FormControl
                sx={{
                  width: '100%',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  color: '#ACB9B5',
                }}>
                <Select
                  displayEmpty
                  id='demo-simple-select'
                  value={formData.project}
                  name='project'
                  onChange={onChangeFormData}
                  placeholder='Select Project'
                  IconComponent={ExpandMoreOutlined}
                  sx={{
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#5F5C5F',
                    border: 'none',
                    ':before': { content: 'none' },
                    boxShadow: 'none',
                    '.MuiOutlinedInput-input': {
                      padding: '14px 12px',
                      borderRadius: '8px',
                      backgroundColor: theme.palette.common.white,
                    },
                    '& .MuiSvgIcon-root': {
                      color: '#5F5C5F',
                      backgroundColor: theme.palette.common.white,
                      borderRadius: '8px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                  }}>
                  <MenuItem value={0}>Select Project</MenuItem>
                  {projects?.map((item: Project) => {
                    return (
                      <MenuItem value={item.id.toString()}>
                        {item.projectName}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={6}>
              <Grid container spacing={2} alignItems='start' sx={{ mb: 2 }}>
                <Grid item sm={6}>
                  <FormControl
                    sx={{
                      width: '100%',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      color: '#ACB9B5',
                    }}>
                    <Select
                      displayEmpty
                      id='demo-simple-select'
                      value={formData.startWorkingHour}
                      name='startWorkingHour'
                      onChange={event => {
                        onChangeFormData(event)
                      }}
                      IconComponent={ExpandMoreOutlined}
                      sx={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                        color: '#5F5C5F',
                        border: 'none',
                        ':before': { content: 'none' },
                        boxShadow: 'none',
                        '.MuiOutlinedInput-input': {
                          padding: '14px 12px',
                          borderRadius: '8px',
                          backgroundColor: theme.palette.common.white,
                        },
                        '& .MuiSvgIcon-root': {
                          color: '#5F5C5F',
                          backgroundColor: theme.palette.common.white,
                          borderRadius: '8px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                      }}>
                      <MenuItem value={0}>Start Working Hour</MenuItem>
                      {Array.from({ length: 24 }).map((item, index) => {
                        return (
                          <MenuItem value={index + 1}>{index + 1}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm={6}>
                  <FormControl
                    sx={{
                      width: '100%',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      color: '#ACB9B5',
                    }}>
                    <Select
                      displayEmpty
                      id='demo-simple-select'
                      value={formData.endWorkingHour}
                      name='endWorkingHour'
                      onChange={event => {
                        onChangeFormData(event)
                      }}
                      IconComponent={ExpandMoreOutlined}
                      sx={{
                        fontSize: '13px',
                        fontWeight: 'bold',
                        color: '#5F5C5F',
                        border: 'none',
                        ':before': { content: 'none' },
                        boxShadow: 'none',
                        '.MuiOutlinedInput-input': {
                          padding: '14px 12px',
                          borderRadius: '8px',
                          backgroundColor: theme.palette.common.white,
                        },
                        '& .MuiSvgIcon-root': {
                          color: '#5F5C5F',
                          backgroundColor: theme.palette.common.white,
                          borderRadius: '8px',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: 'transparent',
                        },
                      }}>
                      <MenuItem value={0}>End Working Hour</MenuItem>
                      {Array.from({ length: 24 }).map((item, index) => {
                        return (
                          <MenuItem value={index + 1}>{index + 1}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Second Row */}
          <Grid container spacing={2} alignItems='start' sx={{ mb: 3 }}>
            <Grid item sm={3}>
              <Box
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  padding: theme.spacing(0.85, 1, 0.85, 1.6),
                }}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label='Basic date picker'
                    value={formData.date}
                    onChange={(newValue: Date | null) => {
                      setFormData({ ...formData, date: newValue })
                    }}
                    renderInput={params => {
                      return (
                        <TextField
                          {...params}
                          variant='standard'
                          label=''
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              // @ts-ignore
                              <IconButton
                                {...params.InputProps}
                                onClick={event => {
                                  // @ts-ignore
                                  params.InputProps.endAdornment.props.children.props.onClick()
                                }}>
                                <CalendarIcon />
                              </IconButton>
                            ),
                          }}
                          sx={{
                            width: '100%',
                            '& .MuiInput-underline:before': {
                              display: 'none',
                            },
                            '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                              {
                                display: 'none',
                              },
                            '& .MuiInput-underline:after': {
                              display: 'none',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
            {/* <Grid item sm={3}>
              <FormControl
                sx={{
                  width: '100%',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  color: '#ACB9B5',
                }}>
                <Select
                  displayEmpty
                  id='demo-simple-select'
                  value={formData.archived}
                  name='archived'
                  onChange={onChangeFormData}
                  IconComponent={ExpandMoreOutlined}
                  sx={{
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#5F5C5F',
                    border: 'none',
                    ':before': { content: 'none' },
                    boxShadow: 'none',
                    '.MuiOutlinedInput-input': {
                      padding: '14px 12px',
                      borderRadius: '8px',
                      backgroundColor: theme.palette.common.white,
                    },
                    '& .MuiSvgIcon-root': {
                      color: '#5F5C5F',
                      backgroundColor: theme.palette.common.white,
                      borderRadius: '8px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                  }}>
                  <MenuItem value={0}>All</MenuItem>
                  <MenuItem value={'true'}>Archived</MenuItem>
                  <MenuItem value={'false'}>Un-Archived</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item sm={3}>
              <FormControl
                sx={{
                  width: '100%',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  color: '#ACB9B5',
                }}>
                <Select
                  displayEmpty
                  id='demo-simple-select'
                  value={formData.checkedin}
                  name='checkedin'
                  onChange={onChangeFormData}
                  IconComponent={ExpandMoreOutlined}
                  sx={{
                    fontSize: '13px',
                    fontWeight: 'bold',
                    color: '#5F5C5F',
                    border: 'none',
                    ':before': { content: 'none' },
                    boxShadow: 'none',
                    '.MuiOutlinedInput-input': {
                      padding: '14px 12px',
                      borderRadius: '8px',
                      backgroundColor: theme.palette.common.white,
                    },
                    '& .MuiSvgIcon-root': {
                      color: '#5F5C5F',
                      backgroundColor: theme.palette.common.white,
                      borderRadius: '8px',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'transparent',
                    },
                  }}>
                  <MenuItem value={0}>All</MenuItem>
                  <MenuItem value={'true'}>Checked-In</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={3}>
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                gap={1.5}>
                <Button
                  variant='contained'
                  sx={{
                    padding: theme.spacing(1.5, 2, 1.5, 2),
                    borderRadius: '8px',
                    textTransform: 'capitalize',
                    width: '100%',
                    fontSize: '13px',
                    // backgroundColor: getParam() != filterParam ? theme.palette.primary.main : '#7C7A80',
                    // '&:hover': {
                    //   backgroundColor: getParam() != filterParam ? theme.palette.primary.main : '#7C7A80',
                    // }
                  }}
                  onClick={handleFilter}>
                  <FilterIcon /> <Box sx={{ width: 10 }} /> Filter
                </Button>
                <Button
                  variant='contained'
                  sx={{
                    padding: theme.spacing(1.5, 2, 1.5, 2),
                    borderRadius: '8px',
                    width: '100%',
                    textTransform: 'capitalize',
                    fontSize: '13px',
                    backgroundColor:
                      filterParam.length > 0
                        ? theme.palette.primary.main
                        : '#7C7A80',
                    '&:hover': {
                      backgroundColor:
                        filterParam.length > 0
                          ? theme.palette.primary.main
                          : '#7C7A80',
                    },
                  }}
                  onClick={resetFilters}>
                  <ResetIcon /> <Box sx={{ width: 10 }} /> Reset Filter
                </Button>
              </Box>
            </Grid>
          </Grid>

          {/* Main Table */}
          <Card
            sx={{
              padding: 1,
              boxShadow: 'none',
              border: '1px solid #EEEEEE',
              borderRadius: '10px',
            }}>
            <CardHeader
              sx={{
                marginBottom: 0,
                paddingBottom: 0,
                paddingTop: '10px !important',
              }}
              title={
                <Box
                  sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    display: 'flex',
                  }}>
                  <Typography sx={{ fontSize: 26, fontWeight: 500 }}>
                    Timesheets
                  </Typography>
                  <Box>
                    <Button
                      id='basic-button-1'
                      aria-controls={
                        Boolean(openLimit) ? 'basic-menu-1' : undefined
                      }
                      aria-haspopup='true'
                      aria-expanded={Boolean(openLimit) ? 'true' : undefined}
                      onClick={(event: any) =>
                        setOpenLimit(event.currentTarget)
                      }
                      sx={{
                        border: '1px solid #DEE2E0',
                        color: 'black',
                        fontWeight: '400',
                        padding: '5px',
                        borderRadius: '10px',
                      }}
                      endIcon={
                        <ChevronRight
                          sx={{ transform: 'rotate(90deg)', color: '#5A525B' }}
                        />
                      }>
                      {limit}
                    </Button>
                    <Menu
                      id='basic-menu-1'
                      anchorEl={openLimit}
                      open={Boolean(openLimit)}
                      onClose={() => setOpenLimit(null)}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button-1',
                      }}
                      sx={{
                        boxShadow: 'none',
                        '& .MuiPaper-root': {
                          boxShadow:
                            '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                          borderRadius: '10px',
                          border: '1px solid #F1EFF5',
                        },
                        '& ul': {
                          padding: '7px 0px',
                          // backgroundColor: 'red',
                          boxShadow: 'none',
                        },
                        '& li:hover': {
                          backgroundColor: 'transparent',
                        },
                        '& li': {
                          margin: '5px 10px',
                          borderBottom: '1px solid #DEE2E0',
                          textAlign: 'left',
                          padding: '5px 0',
                          fontSize: 14,
                          color: '#5F5C5F',
                        },
                        '& li:last-child': {
                          border: 'none !important',
                        },
                        marginTop: 1,
                      }}>
                      {[10, 20, 30].map(item => (
                        <MenuItem
                          sx={{
                            width: 48,
                            textAlign: 'center',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          onClick={() => {
                            setOpenLimit(null)
                            setLimit(item)
                          }}>
                          {item}
                        </MenuItem>
                      ))}
                    </Menu>

                    <Button
                      id='basic-button-1'
                      aria-controls={
                        Boolean(openExportType) ? 'basic-menu-2' : undefined
                      }
                      aria-haspopup='true'
                      aria-expanded={
                        Boolean(openExportType) ? 'true' : undefined
                      }
                      onClick={(event: any) =>
                        setOpenExportType(event.currentTarget)
                      }
                      sx={{
                        border: '1px solid #DEE2E0',
                        color: 'black',
                        fontWeight: '400',
                        padding: '5px 15px',
                        borderRadius: '10px',
                        marginLeft: 1,
                        textTransform: 'capitalize',
                      }}
                      endIcon={
                        <ChevronRight
                          sx={{ transform: 'rotate(90deg)', color: '#5A525B' }}
                        />
                      }>
                      Export
                    </Button>
                    <Menu
                      id='basic-menu-2'
                      anchorEl={openExportType}
                      open={Boolean(openExportType)}
                      onClose={() => setOpenExportType(null)}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button-1',
                      }}
                      sx={{
                        boxShadow: 'none',
                        '& .MuiPaper-root': {
                          boxShadow:
                            '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                          borderRadius: '10px',
                          border: '1px solid #F1EFF5',
                        },
                        '& ul': {
                          padding: '7px 0px',
                          // backgroundColor: 'red',
                          boxShadow: 'none',
                        },
                        '& li:hover': {
                          backgroundColor: 'transparent',
                        },
                        '& li': {
                          margin: '5px 17px',
                          borderBottom: '1px solid #DEE2E0',
                          textAlign: 'left',
                          padding: '5px 0',
                          fontSize: 14,
                          color: '#5F5C5F',
                        },
                        '& li:last-child': {
                          border: 'none !important',
                        },
                        marginTop: 1,
                      }}>
                      {[
                        'Selected Timecards',
                        "Last Week's Projects",
                        "Last Month's Projects",
                        "Last Year's Projects",
                      ].map(item => (
                        <MenuItem
                          sx={{ width: 180 }}
                          onClick={() => {
                            setOpenExportType(null)
                            setExportType(item)
                            handleUploadClick(item)
                          }}>
                          {item}
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                </Box>
              }
            />
            <CardContent
              sx={{ paddingBottom: '15px !important', paddingTop: 0 }}>
              <EmployeeTable
                setSelectedTimesheets={setSelectedTimesheets}
                param={`${filterParam}limit=${limit}&page=${page}`}
                setPage={setPage}
                mutate={useDeleteEmployeeAttendance}
              />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </>
  )
}

const EmployeeTable = ({
  param,
  setPage,
  setSelectedTimesheets,
}: {
  param: any
  setPage: any
  setSelectedTimesheets: any
  mutate: any
}) => {
  const {
    data: employeeAttendances,
    isFetching: isFetchingAttendance,
    refetch,
  } = useGetEmployeeAttendance('employee-attendance-reports', param)
  const { mutate, isLoading: isLoadingDelete } = useDeleteEmployeeAttendance(
    'remove-employee-attendance-reports'
  )
  const [deleteId, setDeleteId] = useState('')
  const [open, setOpen] = useState<boolean>(false)
  const [checkedItems, setCheckedItems] = useState([])
  const { mutate: mutateUpdate, isLoading: isLoadingUpdate } =
    useUpdateEmployeeAttendance('update-employee-attendance-reports')
  const { toggleSnackbar } = useContext(SnackBarContext)

  const handleClickOpen = () => {
    setOpen(true)
  }
  useEffect(() => {
    refetch()
  }, [employeeAttendances])

  const deleteProject = (row: any) => {
    setDeleteId(row)
    handleClickOpen()
  }

  const deleteAction = useCallback(
    (deleteId: any) => {
      mutate(deleteId)
      toggleSnackbar('Report Deleted successfully', 'success')
    },
    [mutate]
  )

  // const toggleArchive = (row: any) => {
  //   mutateUpdate({
  //     projectId: row?._id,
  //     payload: {
  //       isArchived: !(row?.isArchived ? row?.isArchived : false),
  //     },
  //   })
  // }
  // useEffect(() => {
  //   // Update the page state to 1 whenever the filter parameters change
  //   setPage(1);
  // }, [param, setPage]);
  // }, [param, setPage]);

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isFetchingAttendance || isLoadingDelete || isLoadingUpdate}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <TableContainer
        component={Paper}
        sx={{ marginTop: 2, boxShadow: 'none' }}>
        <Table
          sx={{
            minWidth: 650,
            boxShadow: 'none',
          }}
          aria-label='simple table'>
          <TableHead sx={{}}>
            <TableRow
              sx={{
                '& th': {
                  backgroundColor: '#24212C',
                  padding: '7px',
                  color: 'white',
                  fontWeight: 400,
                  whiteSpace: 'nowrap',
                },
                '& th:first-child': {
                  // alignItems: 'center',
                  // display: 'flex',
                  borderRadius: '10px 0px 0px 10px',
                },
                '& th:last-child': {
                  borderRadius: '0px 10px 10px 0px',
                },
              }}>
              <TableCell>
                <Box
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Checkbox
                    checked={(employeeAttendances?.data || [])?.every(
                      (row: any) => checkedItems[row?._id] == true
                    )}
                    onChange={e => {
                      setSelectedTimesheets(
                        (employeeAttendances?.data || []).reduce(
                          (a: any, b: any) => {
                            a[b._id] = e.target.checked ? b : null
                            return a
                          },
                          {}
                        )
                      )
                      setCheckedItems(
                        (employeeAttendances?.data || []).reduce(
                          (a: any, b: any) => {
                            a[b._id] = e.target.checked
                            return a
                          },
                          {}
                        )
                      )
                    }}
                    sx={{ color: 'white', fill: 'white' }}
                  />
                  WORKER NAME
                </Box>
              </TableCell>
              <TableCell>PROJECT</TableCell>
              <TableCell>DATE</TableCell>
              <TableCell>FOREMAN</TableCell>
              <TableCell>CHECK IN</TableCell>
              <TableCell>CHECK OUT</TableCell>
              <TableCell>TOTAL</TableCell>
              <TableCell>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& td': {
                backgroundColor: 'white',
                color: '#5F5C5F',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                padding: '8px',
                fontSize: 14,
              },
              '& td:first-child': {
                borderRadius: '10px 0px 0px 10px',
              },
              '& td:last-child': {
                borderRadius: '0px 10px 10px 0px',
              },
            }}>
            {(employeeAttendances?.data || [])
              .slice()
              ?.map((row: any, index: any) => (
                <TableRow
                  key={row._id}
                  sx={{
                    '& td, & th': {
                      border: 0,
                      background: index % 2 == 0 ? 'white' : '#F1EFF5',
                    },
                  }}>
                  <TableCell scope='row'>
                    <Box
                      style={{
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                      }}>
                      {checkedItems[row?._id] == true ? (
                        <Checkbox
                          checked={true}
                          onChange={e => {
                            setSelectedTimesheets((prev: any) => ({
                              ...prev,
                              [row?._id]: e.target.checked ? row : null,
                            }))
                            setCheckedItems((prev: any) => {
                              return {
                                ...prev,
                                [row?._id]: e.target.checked,
                              }
                            })
                          }}
                          sx={{ color: '#D9D9D9', fill: 'white' }}
                        />
                      ) : (
                        <Checkbox
                          checked={false}
                          onChange={e => {
                            setSelectedTimesheets((prev: any) => ({
                              ...prev,
                              [row?._id]: e.target.checked ? row : null,
                            }))
                            setCheckedItems((prev: any) => {
                              return {
                                ...prev,
                                [row?._id]: e.target.checked,
                              }
                            })
                          }}
                          sx={{ color: '#D9D9D9', fill: 'white' }}
                        />
                      )}
                      <Avatar
                        src={row?.user?.idPhoto}
                        alt={row.name}
                        sx={{ marginRight: 1, width: 35, height: 35 }}
                      />
                      <Box
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '15ch',
                        }}>
                        {row?.user?.firstName} {row?.user?.lastName}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{row?.project?.projectName}</TableCell>
                  <TableCell>
                    {formatDate(row?.formattedTimeDurations?.startTime)}
                  </TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        row?.superintendents?.length > 0
                          ? row.superintendents.map((s: any) => (
                              <Box
                                key={s.id}
                                style={{
                                  flexDirection: 'row',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'left',
                                }}>
                                <Avatar
                                  src={s?.idPhoto ? s?.idPhoto : s?.picture}
                                  alt={'foreman picture'}
                                  sx={{ marginRight: 1, width: 35, height: 35 }}
                                />
                                {s?.firstName ?? '----'}
                                {s?.lastName ?? '----'}
                              </Box>
                            ))
                          : null
                      }>
                      <Box
                        style={{
                          flexDirection: 'row',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'left',
                        }}>
                        <Avatar
                          src={
                            row?.superintendents[0]?.idPhoto
                              ? row?.superintendents[0]?.idPhoto
                              : row?.superintendents[0]?.picture
                          }
                          alt={'foreman picture'}
                          sx={{ marginRight: 1, width: 35, height: 35 }}
                        />
                        {row?.superintendents[0]?.firstName ?? '----'}
                        {row?.superintendents[0]?.lastName ?? '----'}
                      </Box>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    {row?.formattedTimeDurations?.startTime
                      ? formatTime(row?.formattedTimeDurations?.startTime)
                      : '---'}
                  </TableCell>
                  <TableCell>
                    {row?.formattedTimeDurations?.endTime
                      ? formatTime(row?.formattedTimeDurations?.endTime)
                      : 'Open'}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        display: 'flex',
                        justifyContent: 'left',
                        gap: 0,
                      }}>
                      <Typography
                        sx={{
                          fontSize: 14,
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          gap: 0.6,
                        }}>
                        <svg
                          width='16'
                          height='17'
                          viewBox='0 0 16 17'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M1.4375 8.21582C1.4375 9.9563 2.1289 11.6255 3.35961 12.8562C4.59032 14.0869 6.25952 14.7783 8 14.7783C9.74048 14.7783 11.4097 14.0869 12.6404 12.8562C13.8711 11.6255 14.5625 9.9563 14.5625 8.21582C14.5625 6.47534 13.8711 4.80614 12.6404 3.57543C11.4097 2.34472 9.74048 1.65332 8 1.65332C6.25952 1.65332 4.59032 2.34472 3.35961 3.57543C2.1289 4.80614 1.4375 6.47534 1.4375 8.21582Z'
                            stroke='#F0845D'
                            strokeLinecap='round'
                            stroke-linejoin='round'
                          />
                          <path
                            d='M8 8.21582V5.87207'
                            stroke='#F0845D'
                            strokeLinecap='round'
                            stroke-linejoin='round'
                          />
                          <path
                            d='M8 8.21582L10.9294 11.1458'
                            stroke='#F0845D'
                            strokeLinecap='round'
                            stroke-linejoin='round'
                          />
                        </svg>
                        <span style={{ color: '#F0845D' }}>Regular:</span>{' '}
                        {row?.formattedTimeDurations?.regularTimeWorked}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 14,
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          gap: 0.6,
                        }}>
                        {row?.formattedTimeDurations?.overTimeWorked !==
                        '0:00' ? (
                          <>
                            <svg
                              width='16'
                              height='17'
                              viewBox='0 0 16 17'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'>
                              <path
                                d='M1.4375 8.21582C1.4375 9.9563 2.1289 11.6255 3.35961 12.8562C4.59032 14.0869 6.25952 14.7783 8 14.7783C9.74048 14.7783 11.4097 14.0869 12.6404 12.8562C13.8711 11.6255 14.5625 9.9563 14.5625 8.21582C14.5625 6.47534 13.8711 4.80614 12.6404 3.57543C11.4097 2.34472 9.74048 1.65332 8 1.65332C6.25952 1.65332 4.59032 2.34472 3.35961 3.57543C2.1289 4.80614 1.4375 6.47534 1.4375 8.21582Z'
                                stroke='#7AB3B3'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M8 8.21582V5.87207'
                                stroke='#7AB3B3'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M8 8.21582L10.9294 11.1458'
                                stroke='#7AB3B3'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                            </svg>
                            <span style={{ color: '#7AB3B3' }}>Overtime:</span>{' '}
                            {row?.formattedTimeDurations?.overTimeWorked}{' '}
                          </>
                        ) : null}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 14,
                          alignItems: 'center',
                          justifyContent: 'center',
                          display: 'flex',
                          gap: 0.6,
                        }}>
                        {row?.formattedTimeDurations?.doubleOverTimeWorked !==
                        '0:00' ? (
                          <>
                            <svg
                              width='16'
                              height='17'
                              viewBox='0 0 16 17'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'>
                              <path
                                d='M1.4375 8.21582C1.4375 9.9563 2.1289 11.6255 3.35961 12.8562C4.59032 14.0869 6.25952 14.7783 8 14.7783C9.74048 14.7783 11.4097 14.0869 12.6404 12.8562C13.8711 11.6255 14.5625 9.9563 14.5625 8.21582C14.5625 6.47534 13.8711 4.80614 12.6404 3.57543C11.4097 2.34472 9.74048 1.65332 8 1.65332C6.25952 1.65332 4.59032 2.34472 3.35961 3.57543C2.1289 4.80614 1.4375 6.47534 1.4375 8.21582Z'
                                stroke='#7C7A80'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M8 8.21582V5.87207'
                                stroke='#7C7A80'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                              <path
                                d='M8 8.21582L10.9294 11.1458'
                                stroke='#7C7A80'
                                strokeLinecap='round'
                                stroke-linejoin='round'
                              />
                            </svg>
                            <span style={{ color: '#7C7A80' }}>
                              Doubletime:
                            </span>{' '}
                            {row?.formattedTimeDurations?.doubleOverTimeWorked}
                          </>
                        ) : null}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 5,
                      }}>
                      <ViewWorkerModel data={row} />
                      <Button
                        sx={{
                          padding: '1.5px 12px',
                          textTransform: 'capitalize',
                          borderRadius: 2,
                          boxShadow: 'none',
                          minWidth: 0,
                          backgroundColor: '#8E221880',
                          '&:hover': {
                            backgroundColor: '#8E221880',
                            boxShadow: 'none',
                          },
                          fontSize: 13,
                        }}
                        onClick={() => deleteProject(row?._id)}
                        variant='contained'
                        color='secondary'>
                        Delete
                      </Button>
                      {/* <Button
                        sx={{
                          padding: '1.5px 12px',
                          textTransform: 'capitalize',
                          borderRadius: 2,
                          boxShadow: 'none',
                          backgroundColor: '#59A0A0CC',
                          '&:hover': {
                            backgroundColor: '#59A0A0CC',
                            boxShadow: 'none',
                          },
                          minWidth: 0,
                          fontSize: 13,
                        }}
                        variant='contained'
                        onClick={() => toggleArchive(row)}>
                        {row?.isArchived ? 'Archived' : 'Unarchive'}
                      </Button> */}

                      <EditTimesheetModel data={row} />
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        alignItems={'flex-end'}
        display={'flex'}
        justifyContent={'end'}
        mt={1}>
        <Pagination
          count={employeeAttendances?.pageCount || 0}
          onChange={(event, page) => setPage(page)}
          color='primary'
        />
      </Box>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteAction={() => deleteAction(deleteId)}
      />
    </>
  )
}

export default EmployeesAttendanceReport
